import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { FeaturePageStructuredData } from "../../config/StructuredData";

const DocumentCollection = () => (
  <>
    <FeaturePageStructuredData
      name="Document Collection and Pending Tracking"
      description="Track which documents are pending from which client with Simplifyte. Automated reminders replace WhatsApp follow-ups for document collection."
      url="https://www.simplifyte.com/features/document-collection"
    />
    <HeaderMenu />
    <main style={{ paddingTop: "80px", minHeight: "100vh" }}>
      <section style={{ background: "linear-gradient(135deg,#093A5B 0%,#0a4d6e 100%)", padding: "60px 24px", color: "#fff", textAlign: "center" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <p style={{ fontSize: "13px", letterSpacing: "2px", textTransform: "uppercase", opacity: 0.7, marginBottom: "16px" }}>Features</p>
          <h1 style={{ fontSize: "clamp(26px,4vw,44px)", fontWeight: 700, lineHeight: 1.2, marginBottom: "20px" }}>Document Collection and Pending Tracking</h1>
          <p style={{ fontSize: "17px", opacity: 0.85, maxWidth: "640px", margin: "0 auto 32px" }}>Know exactly which documents are pending from which client — and send automated reminders instead of manual WhatsApp follow-ups.</p>
          <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "12px 28px", borderRadius: "8px", fontWeight: 600, textDecoration: "none" }}>Book a Demo</Link>
        </div>
      </section>

      <section style={{ padding: "60px 24px" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "26px", fontWeight: 700, color: "#093A5B", marginBottom: "16px" }}>The document collection problem in CA firms</h2>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7, marginBottom: "16px" }}>
            CA firms and professional service teams spend a huge portion of their time chasing documents — Form 16, bank statements, investment proofs, TDS certificates, GST invoices. These requests go over WhatsApp, get buried, get re-sent, and still arrive late.
          </p>
          <p style={{ fontSize: "16px", color: "#475569", lineHeight: 1.7 }}>
            Simplifyte replaces this with a structured document checklist per client and work item — with automated reminders, a pending status view, and a received log that shows when each document arrived.
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: "16px", marginTop: "32px" }}>
            {["Document checklist per work item","Pending-from-client status always visible","Automated reminders to clients","Received documents logged with timestamp","No more duplicate WhatsApp follow-ups"].map((t,i)=>(
              <div key={i} style={{ background: "#f8fafc", padding: "16px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "14px", color: "#475569" }}>✓ {t}</div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: "40px 24px", background: "#f8fafc" }}>
        <div style={{ maxWidth: "820px", margin: "0 auto" }}>
          <h2 style={{ fontSize: "24px", fontWeight: 700, color: "#093A5B", marginBottom: "24px" }}>Before Simplifyte / With Simplifyte</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
            <div style={{ background: "#fff5f5", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#ef4444", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>Before Simplifyte</h3>
              {["Document requests sent on WhatsApp","Reminders sent manually, often forgotten","Staff unsure what arrived and what is pending","Same document requested twice because of no log","Client complains about repeated follow-ups"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #fca5a5" }}>{t}</p>))}
            </div>
            <div style={{ background: "#f0fdf4", padding: "20px", borderRadius: "10px" }}>
              <h3 style={{ color: "#16a34a", marginBottom: "12px", fontSize: "15px", fontWeight: 600 }}>With Simplifyte</h3>
              {["Document checklist per work item in the system","Automated reminders at set intervals","Pending vs received status always current","No duplicate requests — log is visible to all","Professional client experience, not WhatsApp chaos"].map((t,i)=>(<p key={i} style={{ fontSize: "14px", color: "#64748b", marginBottom: "8px", paddingLeft: "8px", borderLeft: "2px solid #86efac" }}>{t}</p>))}
            </div>
          </div>
        </div>
      </section>

      <section style={{ padding: "60px 24px", textAlign: "center", background: "#093A5B", color: "#fff" }}>
        <h2 style={{ fontSize: "26px", fontWeight: 700, marginBottom: "14px" }}>Stop chasing documents on WhatsApp</h2>
        <Link to="/contactsales" style={{ background: "#fff", color: "#093A5B", padding: "13px 30px", borderRadius: "8px", fontWeight: 600, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "8px" }}>Book a Demo <ArrowRight size={16} /></Link>
      </section>
    </main>
    <CustomFooter />
  </>
);

export default DocumentCollection;
